// src/services/userApi.ts
import { API_DOMAIN } from './apiConfig';

// Fetch user profile using access token
export async function fetchUserProfile(accessToken: string) {
  const res = await fetch(
    `${API_DOMAIN}/web/content/user/profile/all?accessToken=${accessToken}`,
  );
  if (!res.ok) throw new Error('Failed to fetch user profile');
  const data = await res.json();
  return data?.responseObject?.userProfile;
}
